<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 10em">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div>
          <div class="row">
            <div class="col-12">
              <button_back></button_back>
            </div>
            <div class="col-lg-12">
              <div class="mt-2 mb-3">
                <h3 class="text-orange fw-bold">
                  {{ solicitud.nombre_aliado }}
                </h3>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-8">
              <div class="card">
                <div class="card-body">
                  <h4 class="text-orange fw-bold mb-3 mt-2">
                    Detalle de solicitud
                  </h4>
                  <div v-if="solicitud.length != 0">
                    <div class="mt-3 mb-3">
                      <span v-if="solicitud.estado_solicitud == 0" class="badge bg-warning">
                        Solicitud pendiente
                      </span>
                      <span v-if="solicitud.estado_solicitud == 1" class="badge bg-info">
                        Solicitud en desarrollo
                      </span>
                      <span v-if="solicitud.estado_solicitud == 2" class="badge bg-primary">
                        Solicitud terminada
                      </span>
                      <span v-if="solicitud.estado_solicitud == 4" class="badge bg-success">
                        Solicitud aprobada
                      </span>
                      <span v-if="solicitud.estado_solicitud == 5" class="badge bg-danger">
                        Solicitud cancelada
                      </span>
                      <span v-if="solicitud.estado_solicitud == 6" class="badge bg-warning">
                        Solicitud no aprobada
                      </span>
                      <div class="card card-body shadow border mt-3 mb-3">
                        <div v-if="session.usuario.perfil == 2">
                          <div class="form-group">
                            <label>Cambiar estado a</label>
                            <select v-model="solicitud.estado_solicitud" class="form-control">
                              <option value="0">Pendiente</option>
                              <option value="1">En desarrollo</option>
                              <option value="2">Terminada</option>
                              <option value="5">Cancelada</option>
                            </select>
                          </div>
                          <a v-if="solicitud.archivo_entrega != null" v-bind:href="solicitud.archivo_entrega"
                            target="_blank">
                            <i class="bx bxs-file-jpg"></i> Archivo entregado
                          </a>
                          <div v-if="
                            solicitud.estado_solicitud == 2 ||
                            solicitud.estado_solicitud == 6
                          ">
                            <div class="form-group mt-4 mb-4" v-if="solicitud.vertical == 1">
                              <label>Subir/modificar piezza redes</label>
                              <input @change="on_file_change_redes" type="file" class="form-control" />
                            </div>
                            <div class="form-group mt-4 mb-4" v-if="solicitud.horizontal == 1">
                              <label>Subir/modificar piezza revista</label>
                              <input @change="on_file_change_revista" type="file" class="form-control" />
                            </div>
                            <div class="form-group mt-4 mb-4" v-if="solicitud.app == 1">
                              <label>Subir/modificar pieza app</label>
                              <input @change="on_file_change_app" type="file" class="form-control" />
                            </div>
                          </div>
                          <div class="text-end">
                            <button v-if="
                              solicitud.estado_solicitud == 2 ||
                              solicitud.estado_solicitud == 6
                            " v-on:click="upload" class="btn btn-success rounded-pill">
                              <i class="bx bx-save"></i> Guardar
                            </button>
                            <button v-else v-on:click="update_estado" class="btn btn-success rounded-pill">
                              <i class="bx bx-save"></i> Guardar
                            </button>
                          </div>
                        </div>
                        <div v-if="
                          session.usuario.perfil == 0 ||
                          session.usuario.perfil == 1
                        ">
                          <div class="form-group">
                            <a v-if="solicitud.archivo_entrega_revista != null"
                              v-bind:href="solicitud.archivo_entrega_revista" target="_blank">
                              <i class="bx bxs-file-jpg"></i> Archivo revista entregado
                            </a>
                          </div>
                          <div class="form-group">
                            <a v-if="solicitud.archivo_entrega_redes != null"
                              v-bind:href="solicitud.archivo_entrega_redes" target="_blank">
                              <i class="bx bxs-file-jpg"></i> Archivo redes entregado
                            </a>
                          </div>
                          <div class="form-group">
                            <a v-if="solicitud.archivo_entrega_app != null" v-bind:href="solicitud.archivo_entrega_app"
                              target="_blank">
                              <i class="bx bxs-file-jpg"></i> Archivo app entregado
                            </a>
                          </div>
                          <div class="form-group">
                            <label>Cambiar estado a</label>
                            <select v-model="solicitud.estado_solicitud" class="form-control">
                              <option value="0">Pendiente</option>
                              <option value="1">En desarrollo</option>
                              <option value="2">Terminada</option>
                              <option value="4">Aprobada</option>
                              <option value="5">Cancelada</option>
                              <option value="6">No aprobada</option>
                            </select>
                          </div>
                          <div class="form-group">
                            <label>Observaciones</label>
                            <textarea v-model="nueva_observacion" class="form-control" />
                          </div>
                          <div class="text-end">
                            <button v-on:click="update_estado" class="btn btn-success rounded-pill">
                              <i class="bx bx-refresh"></i> Actualizar
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <table class="table table-bordered table-condensed table-hover my_table_1">
                      <thead>
                        <tr>
                          <th style="width: 5%" class="text-center">Logo</th>
                          <th style="width: 5%" class="text-center">Foto publicitaria</th>
                          <th style="width: 5%" class="text-center">
                            Ficha
                          </th>
                          <th style="width: 5%" class="text-center">
                            Descuento
                          </th>
                          <th style="width: 20%" class="text-center">
                            Descripcion
                          </th>
                          <th style="width: 10%" class="text-center">
                            Piezas
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="text-center">
                            <a v-bind:href="solicitud.logo" target="_blank" class="fw-bold text-orange">
                              <i class="bx bx-download"></i> Descargar
                            </a>
                          </td>
                          <td class="text-center">
                            <a v-bind:href="solicitud.archivo" target="_blank" class="fw-bold text-orange">
                              <i class="bx bx-download"></i> Descargar
                            </a>
                          </td>
                          <td class="text-center">
                            <router-link v-bind:to="
                              '/aliado/ficha/' + solicitud.id_aliado
                            " class="btn btn-success rounded-pill" target="_blank"><i class="bx bxs-check-circle"></i>
                            </router-link>
                          </td>
                          <td class="text-center">
                            <h5 class="fw-bold text-orange">
                              {{ solicitud.descuento }}%
                            </h5>
                          </td>
                          <td class="text-center">
                            <h5 class="fw-bold text-orange" v-if="solicitud.descripcion">
                              {{ solicitud.descripcion }}
                            </h5>
                            <h5 class="fw-bold text-orange" v-else>
                              No tiene descripcion
                            </h5>
                          </td>
                          <td class="text-center">
                            <span v-if="solicitud.horizontal == 1" class="text-orange fw-bold">
                              <i class="bx bxs-check-circle"></i>
                              Redes sociales </span><br />
                            <span v-if="solicitud.vertical == 1" class="text-orange fw-bold">
                              <i class="bx bxs-check-circle"></i> Revista
                            </span>
                            <span v-if="solicitud.app == 1" class="text-orange fw-bold">
                              <i class="bx bxs-check-circle"></i> app
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="card">
                <div class="card-header">
                  <h5 class="text-muted fw-bold">Observaciones</h5>
                </div>
                <div class="card-body">
                  <div v-for="(
                                                          observacion, index_observacion
                                                        ) in solicitud.observaciones" v-bind:key="index_observacion">
                    <div class="d-flex align-items-start">
                      <div class="flex-grow-1">
                        <strong>{{ observacion.usuario }}</strong>
                        <div class="border text-sm text-muted p-2 mt-1">
                          {{ observacion.observacion }}
                        </div>
                        <small class="text-muted">{{ observacion.fecha }}</small><br />
                      </div>
                    </div>
                    <hr />
                  </div>
                  <div class="mt-3 mb-3">
                    <textarea v-model="nueva_observacion" class="form-control" />
                    <div class="text-end">
                      <a v-on:click="set_observacion" href="javascript:void(0)">
                        <i class="bx bx-message-add"></i> Agregar
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { defineAsyncComponent } from 'vue';
export default {
  name: "Solicitud",
  metaInfo: {
    title: "Detalle de solicitud - Reddy Backoffice",
  },
  components: {
    button_back: defineAsyncComponent(() => import('../../components/BackBtn')),
  },
  data() {
    return {
      loading: true,
      id_solicitud: null,
      solicitud: [],
      hay_archivo: false,
      file_redes: null,
      file_revista: null,
      file_app: null,
      nueva_observacion: null,
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.id_solicitud = this.$route.params.id_solicitud;

    this.get_solicitud();
  },
  methods: {
    get_solicitud: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(
          this.$base_url + "aliados/solicitud_pieza/" + this.id_solicitud,
          config,
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.solicitud = response.data.data.solicitud;
          this.loading = false;
          console.log(this.solicitud);
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    on_file_change_redes(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.hay_archivo = false;
        return;
      }
      this.file_redes = files;
      this.hay_archivo = true;
    },
    on_file_change_revista(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.hay_archivo = false;
        return;
      }
      this.file_revista = files;
      this.hay_archivo = true;
    },
    on_file_change_app(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.hay_archivo = false;
        return;
      }
      this.file_app = files;
      this.hay_archivo = true;
    },
    upload: function () {
      this.upload_revista()
      this.upload_redes()
      this.upload_app()
    },
    upload_revista: function () {
      this.hay_archivo = false;
      this.loading = true;
      var formData = new FormData();
      formData.append("files", this.file_revista[0]);
      formData.append("token", this.session.token);
      formData.append("id_solicitud", this.id_solicitud);
      const vm = this;
      axios
        .post(this.$base_url + "upload/entregar_solicitud_revista", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.status) {
            vm.hay_archivo = false;
            vm.$notify({
              group: "foo",
              type: "success",
              title: "Excelente!",
              text: "Se ha subido el archivo.",
            });
            vm.loading = false;
            vm.get_solicitud();
          } else {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Ups!",
              text: response.data.message,
            });
            vm.loading = false;
          }
        })
        .catch((error) => {
          vm.$notify({
            group: "foo",
            type: "error",
            title: "Ups",
            text: error,
          });
          console.log(error);
          vm.loading = false;
        });
    },
    upload_redes: function () {
      this.hay_archivo = false;
      this.loading = true;
      var formData = new FormData();
      formData.append("files", this.file_redes[0]);
      formData.append("token", this.session.token);
      formData.append("id_solicitud", this.id_solicitud);
      const vm = this;
      axios
        .post(this.$base_url + "upload/entregar_solicitud_redes", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.status) {
            vm.hay_archivo = false;
            vm.$notify({
              group: "foo",
              type: "success",
              title: "Excelente!",
              text: "Se ha subido el archivo.",
            });
            vm.loading = false;
            vm.get_solicitud();
          } else {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Ups!",
              text: response.data.message,
            });
            vm.loading = false;
          }
        })
        .catch((error) => {
          vm.$notify({
            group: "foo",
            type: "error",
            title: "Ups",
            text: error,
          });
          console.log(error);
          vm.loading = false;
        });
    },
    upload_app: function () {
      this.hay_archivo = false;
      this.loading = true;
      var formData = new FormData();
      formData.append("files", this.file_app[0]);
      formData.append("token", this.session.token);
      formData.append("id_solicitud", this.id_solicitud);
      const vm = this;
      axios
        .post(this.$base_url + "upload/entregar_solicitud_app", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.status) {
            vm.hay_archivo = false;
            vm.$notify({
              group: "foo",
              type: "success",
              title: "Excelente!",
              text: "Se ha subido el archivo.",
            });
            vm.loading = false;
            vm.get_solicitud();
          } else {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Ups!",
              text: response.data.message,
            });
            vm.loading = false;
          }
        })
        .catch((error) => {
          vm.$notify({
            group: "foo",
            type: "error",
            title: "Ups",
            text: error,
          });
          console.log(error);
          vm.loading = false;
        });
    },
    update_estado: function () {
      this.loading = true;
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        id_solicitud: this.id_solicitud,
        estado: this.solicitud.estado_solicitud,
        observaciones: this.nueva_observacion,
      };
      axios
        .post(this.$base_url + "aliados/update_estado_solicitud", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Ups",
              text: response.data.message,
            });
            return false;
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Excelente",
              text: response.data.message,
            });
            vm.get_solicitud();
            vm.nueva_observacion = null;
          }

          vm.loading = false;
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    set_observacion: function () {
      this.loading = true;
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        id_solicitud: this.id_solicitud,
        observaciones: this.nueva_observacion,
      };
      axios
        .post(this.$base_url + "aliados/set_observacion_solicitud", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Ups",
              text: response.data.message,
            });
            return false;
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Excelente",
              text: response.data.message,
            });
            vm.get_solicitud();
            vm.nueva_observacion = null;
          }

          vm.loading = false;
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
  },
};
</script>